import { Box, Text } from '@factorialco/deprecated-design-system'
import type { FormsScheduleRecurrenceTypeEnum } from 'generated/resources/datatable.graphql'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

interface Props {
  value: FormsScheduleRecurrenceTypeEnum
  onChange: (value: FormsScheduleRecurrenceTypeEnum) => void
}

export function RecurrenceSelect({ value, onChange }: Props) {
  const options: { label: string; value: FormsScheduleRecurrenceTypeEnum }[] = [
    { label: i18n.t('forms.schedule.recurrence_options.onetime'), value: 'onetime' },
    { label: i18n.t('forms.schedule.recurrence_options.daily'), value: 'daily' },
    { label: i18n.t('forms.schedule.recurrence_options.weekly'), value: 'weekly' },
    { label: i18n.t('forms.schedule.recurrence_options.monthly'), value: 'monthly' },
    { label: i18n.t('forms.schedule.recurrence_options.yearly'), value: 'yearly' },
    { label: i18n.t('forms.schedule.recurrence_options.quarterly'), value: 'quarterly' },
  ]

  return (
    <Box gap="s8">
      <SelectField
        label={i18n.t('forms.schedule.recurrence')}
        value={value}
        onChange={(recurrence) => {
          // @ts-expect-error: Gamma select is not typed and we can't use assertions
          onChange(recurrence)
        }}
        options={options}
      />
      <Text.Normal size="200" color="grey700">
        {i18n.t('forms.schedule.recurrence_description')}
      </Text.Normal>
    </Box>
  )
}
